import { useContext } from "react";
import { Typography } from "@mui/material";
import { UserContext } from "../../components/Context/userContext";
import MarketingNavigation from "../../navigation/marketing";
import Layout from "../../components/Layout";
import StaffReports from "../../components/Staff/ExportsAndReports/Reports";
import StaffExports from "../../components/Staff/ExportsAndReports/Exports";



export default function Staff() {
  const { state: userContext } = useContext(UserContext);

  return (
    <MarketingNavigation isAdmin>
      <Layout>
        {userContext?.user?.isStaff ? (
          <div>
            <Typography
              variant="h1"
              className="mt-3 font-normal"
              color="secondary"
            >
              Staff Dashboard
            </Typography>
            <Typography variant="h2" className="mt-3 font-normal">
              Welcome to the Staff Dashboard
            </Typography>
          </div>
        ) : (
          <></>
        )}
        <div className="w-full max-w-screen-2xl flex gap-6 mt-6 pb-[80px] flex-col sm:flex-row">
          <div className="w-full md:w-2/3">
            <Typography variant="h2" className="mt-3 font-normal" color='secondary'>
              Reports
            </Typography>
            <div>
              <StaffReports />
            </div>
          </div>
          <div className="w-full md:w-1/3">
            <Typography variant="h2" className="mt-3 font-normal" color='secondary'>
              Exports
            </Typography>
            <div>
              <StaffExports />
            </div>
          </div>
        </div>
      </Layout>
    </MarketingNavigation>
  );
}

Staff.getLayout = (page) => <>{page}</>;
Staff.isStaff = true;
